import { IUser } from '../user';
import { Token, TokenClass, TokenParameters, TokenType } from './token';

export class ThirdPartyToken extends Token {
  private readonly _token: string;

  constructor(token: string, tokenClass: TokenClass) {
    super(TokenType.originating, tokenClass);
    this._token = token;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  exchange(_: string, __: string, ___: Array<string>): Promise<Token> {
    return Promise.reject('Unsupported operation');
  }

  expire(): Promise<void> {
    return Promise.resolve();
  }

  get expired(): boolean {
    return false;
  }

  get expires(): number {
    return 0;
  }

  get header(): string | null {
    switch (this.tokenClass) {
      case TokenClass.google:
        return `GoogleJWT ${this.token}`;
      case TokenClass.facebook:
        return `Facebook ${this.token}`;
      case TokenClass.apple:
        return `Apple ${this.token}`;
      default:
        throw new Error('Unsupported token class');
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  initialize(_: Token | null, __: (token: Token) => void): void {}

  get initialized(): boolean {
    return true;
  }

  get invalid(): boolean {
    return false;
  }

  get originatingId(): string | null {
    return null;
  }

  refresh(): Promise<Token> {
    return Promise.reject('Unsupported operation');
  }

  get refreshToken(): string | null {
    return null;
  }

  get refreshable(): boolean {
    return false;
  }

  get scopes(): Array<string> {
    return [];
  }

  setValid(): Promise<void> {
    return Promise.resolve(undefined);
  }

  toParameters(): TokenParameters {
    throw new Error('Unsupported operation');
  }

  get token(): string | null {
    return this._token;
  }

  get user(): IUser {
    throw new Error('Unsupported operation');
  }

  get willExpireSoon(): boolean {
    return false;
  }
}
